import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { faTimes, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FilesService } from 'src/app/services/files/files.service';
import { mspFileInterface } from '../../util/interfaces/mspFile';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'cpi-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit, OnChanges {
	icons = {
		faUpload: faUpload,
		faTimes: faTimes,
	};

	@Output()
	getFiles = new EventEmitter();

	@Input()
	cleanFiles = false;

	@Input()
	labels: LabelsInterface = {
		lbl_importar_arquivos: 'Import files',
	};

	constructor(private FileService: FilesService) {}

	fileList: File[] = [];
	mspFileList: mspFileInterface[] = [];

	isDraggingFileOver = false;
	isConvertingFile = false;

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.cleanFiles && changes.cleanFiles.currentValue === true) {
			this.doCleanFiles();
			setTimeout(() => {
				this.cleanFiles = false;
			}, 1);
		}
	}

	handleFile(event: Event): void {
		this.isDraggingFileOver = false;
		const target = event.target as HTMLInputElement;
		const files = target.files as FileList;
		if (files.length === 0) return;
		this.fileList.push(files[0]);
		this.isConvertingFile = true;
		this.FileService.MSPFileFromFile(files[0]).then((mspFile) => {
			this.isConvertingFile = false;
			this.mspFileList.push(mspFile);

			this.emitMspFiles();
		});
	}

	removeFile(fileIndex: number): void {
		this.fileList.splice(fileIndex, 1);
		this.mspFileList.splice(fileIndex, 1);

		this.emitMspFiles();
	}

	doCleanFiles(): void {
		this.fileList = [];
		this.mspFileList = [];
		this.isDraggingFileOver = false;
		this.isConvertingFile = false;
	}

	emitMspFiles(): void {
		this.getFiles.emit(JSON.stringify(this.mspFileList));
	}
}
